import { Subject, takeUntil } from 'rxjs';
import { Component } from '@angular/core';
import { MobileAuthService, MobileCardService, MobileReputationService } from '@sifca-monorepo/clients';
import { CardRepresentationEnum, CorporateUserCardType, LoyaltySettingsType } from '@sifca-monorepo/widget-generator';

@Component({
  template: '',
})
export class MobileCardComponent {
  protected unsubscribeAll: Subject<void> = new Subject<void>();

  phone: string;
  email: string;
  content: string;
  identifier: string;
  selectedCard: CorporateUserCardType;
  loyaltySettings: LoyaltySettingsType;
  representation: CardRepresentationEnum;
  loadingCard$ = this.cardService.loadingCard$;

  constructor(
    protected authService: MobileAuthService,
    protected cardService: MobileCardService,
    protected reputationService: MobileReputationService,
  ) {
    this.reputationService.loyaltySettings$.pipe(takeUntil(this.unsubscribeAll)).subscribe((settings) => {
      this.loyaltySettings = settings;
      this.representation = settings?.loyaltyCard?.representation?.representation || CardRepresentationEnum.CARD;
      this.content = this.getQrContent();
    });
    this.cardService.userCard$.pipe(takeUntil(this.unsubscribeAll)).subscribe((userCard) => {
      if (userCard) {
        this.selectedCard = userCard;
      }
    });
    this.authService.currentUser$.pipe(takeUntil(this.unsubscribeAll)).subscribe((currentUser) => {
      if (this.representation === CardRepresentationEnum.IDENTIFIER) {
        this.identifier = currentUser?.socialLoginData?.partner?.identifier;
      }
      if (this.representation === CardRepresentationEnum.EMAIL) {
        this.email = currentUser?.email;
      }
      if (this.representation === CardRepresentationEnum.PHONE) {
        this.phone = currentUser?.phone?.number;
      }
    });
  }

  getQrContent(): string {
    switch (this.representation) {
      case 'CARD':
        return this.selectedCard?.identifier || '';
      case 'PHONE':
        return this.phone;
      case 'EMAIL':
        return this.email;
      case 'IDENTIFIER':
        return this.identifier;
      default:
        return '';
    }
  }

  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
}
